/**
 * @param props
 */

export default (props) => {
    return {

        fullscreen: false,
        mounted() {
            //this.service.photo = null;
        },
        loadPhoto(item) {
            if (typeof item !== 'undefined') {
                this.service.post.slice = item.slice;
                this.service.post.index = item.index;
                this.service.photo = item;
            }
        },
        loadSlice() {
            let items = [];
            Object.values(this.service.post.photos).forEach((photo) => {
                if (photo.slice === this.service.post.slice) {
                    items.push(photo);
                }
            })
            return items;
        },

        hidePhoto() {
            this.service.photo = null;
        },

        likePhoto(id) {
            fetch('/photo/like/' + id)
                .then((r) => r.json())
                .then((r) => {
                    this.service.photo.liked = (r.action === 'like');
                    this.service.photo.likes = r.likes;
                });
        },

        prevActive() {
            return typeof this.service.post.photos[this.service.post.index - 1] !== "undefined";
        },

        prevPhoto() {
            if ( typeof this.service.post.photos[this.service.post.index - 1] !== "undefined" ) {
                this.service.photo = this.service.post.photos[this.service.album.index - 1];
                this.loadPhoto(this.service.photo);
            }
        },

        nextActive() {
            return typeof this.service.post.photos[this.service.post.index + 1] !== "undefined";
        },

        nextPhoto() {
            if ( typeof this.service.post.photos[this.service.post.index + 1] !== "undefined" ) {
                this.service.photo = this.service.post.photos[this.service.post.index + 1];
                this.loadPhoto(this.service.photo);
            }
        }

    }
};
